// import { browserHistory } from 'react-router';

export function getIdOrSlugFromPath(path) {
  let slug = path.toString();
  if (slug) {
    slug = slug.replace(/app_dev.php\//, '');
    if (slug.indexOf('admin/contenteditor/view/content') !== -1) {
      slug = slug.replace(/admin\/contenteditor\/view\/content\//, '');
    } else if (slug.indexOf('admin/contenteditor/view/template') !== -1) {
      slug = slug.replace(/admin\/contenteditor\/view\/template\//, '');
    }
  }

  return slug || 'index';
}

export function getTypeFromPath(path) {
  if (path.toString().indexOf('admin/contenteditor/view/template') !== -1) {
    return 'template';
  }

  return 'content';
}

export function getModeFromPath(path) {
  if (path.toString().indexOf('admin/contenteditor/view/content') !== -1 || path.toString().indexOf('admin/contenteditor/view/template') !== -1) {
    return 'manage';
  }

  return 'public';
}

/**
 * Replaces variables defined in string values to the corresponding state var.
 *
 * A variable can be defined in a string like `some text before { form.formname.values.fieldname } some text after`.
 *
 * @param {string} value
 * @param {object} state
 */
export function replaceStateVariables(value, state) {
  if (!value || typeof value !== 'string') {
    return value || '';
  }

  return value.replace(/{(.*)}/g, (match, variable) => {
    const updated = variable.trim().split('.').reduce((o, i) => o[i], state);
    if (updated && (typeof value === 'string' || typeof value === 'number')) {
      return updated;
    }
    return '';
  });
}

/**
 * Change the url for a section change
 *
 * @param {number} section
 */
export function changeSectionUrl() {
  // browserHistory.push(`${window.location.pathname}?section=${section}`);
  window.scrollTo(0, 0);
}
